<div class="driver-list-component">
  <div class="col-md-12 no-padding">
    <legend>Drivers</legend>
    <div class="trips-tab-body">
      <lgt-grid-static
        [cols]="cols"
        [data]="tripList"
        [selectCol]="true"
        [onDblClick]="viewDetail"
        [showPrintInvoice]="false"
        [showNewButton]="true"
        [newButtonOptions]="newButtonOptions"
        [newButtonAction]="newButtonAction"
        [filters]="filters"
        [loadData]="loadData"
        [showExcelButton]="true"
        [onExcelButton]="excelGeneration"
        [useSignalR]="false"
        [pageName]="'driver-list'"
      />
    </div>
  </div>
</div>